import React from "react";
import styled from "styled-components";

export default function FutureProjectBox({title, text, location,  date, image}) {
  return (
      <Wrapper className="whiteBg radius8 shadow">
        <h3 className="font20 extraBold">{title}</h3>
        <ProjectImage src={image}/>
        <p className="font13" style={{ padding: "30px 0" }}>
          {text}
        </p>
        <div className="flex">
          <p className="tag coralBg radius6 font13 extraBold">In {location} on {date}</p>
        </div>
      </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  text-align: left;
  padding: 20px 30px;
  margin-top: 30px;
`;
const WrapperBtn = styled.button`
  border: 0px;
  outline: none;
  background-color: transparent;
  :hover {
    opacity: 0.5;
  }
`;
const ProjectImage = styled.img`
  width: 100%;
  margin: 0px auto;
`;
